<template>
  <div class="signup-container">
    <h3 class="title">{{ $t('send-document-for-signing-today') }}</h3>
    <FriedInput
      :model-value="emailInput"
      class="email-input"
      data-external="after-sign-modal-email-input"
      :label="$t('email')"
      :error-message="errorMessage"
      @update:model-value="handleInput"
    />
  </div>
</template>

<script lang="ts">
import type { SigningPageRecipient } from '@getaccept/lib-shared-new/src/types/signing-page-recipient';
import type { PropType } from 'vue';
import { computed, ref, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      required: true,
    },
    error: {
      type: String,
      default: '',
    },
    didYouMean: {
      type: String,
      default: '',
    },
  },
  emits: ['email'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const emailInput = ref(props.recipient.email || '');

    const errorMessage = computed((): string => {
      if (!props.error) {
        return '';
      }
      if (props.didYouMean) {
        return `${t('email-error-did-you-mean')}: ${props.didYouMean}`;
      }
      if (props.error === 'Unreachable') {
        return `${t('could-not-verify-email-address')}`;
      }
      return t('could-not-sign-up');
    });

    const handleInput = () => {
      emit('email', emailInput.value);
    };

    return {
      emailInput,
      errorMessage,
      handleInput,
    };
  },
});
</script>
<style lang="scss" scoped>
.signup-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  .email-input-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    @media only screen and (max-width: $xs) {
      flex-wrap: wrap;
    }
  }

  .title {
    text-align: center;
  }

  .email-input-error {
    color: var(--error-dark);
    text-align: left;
  }
}
</style>
